<script setup lang="ts">
import { computed } from 'vue';
import {
  tokenAmountFormat,
  TokenAmountFormatConfig,
} from '../helpers/tokenAmountFormat';
import { useAppStore } from '@/store/app';

const props = defineProps<{
  config?: TokenAmountFormatConfig;
}>();

const app = useAppStore();

const tokenAmountString = computed(() => {
  if (app.hideValues) {
    return '*****';
  }
  return tokenAmountFormat(props.config);
});
</script>

<template>
  <span class="text-no-wrap">
    {{ tokenAmountString }}
  </span>
</template>
